const darkBlue = '#003a8c';
const lightBlue = '#1890ff';
const offWhite = '#f0f6fa';
const black = '#000000';
const white = '#ffffff';
const errorRed = '#ff4d4f';
const successGreen = '#05821e';
const grey = '#3a3a3a';
const orange = '#da6d01';

export {darkBlue, lightBlue, offWhite, black, white, errorRed, successGreen, grey, orange};